var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useTheme, createComponent, focusRing, } from '@workday/canvas-kit-react/common';
import { colors } from '@workday/canvas-kit-react/tokens';
import { BaseButton, getMinWidthStyles, getPaddingStyles } from './BaseButton';
var getPrimaryButtonColors = function (variant, theme) {
    var themePrimary = theme.canvas.palette.primary;
    switch (variant) {
        case undefined:
        default:
            return {
                default: {
                    background: themePrimary.main,
                    icon: themePrimary.contrast,
                    label: themePrimary.contrast,
                },
                hover: {
                    background: themePrimary.dark,
                },
                active: {
                    background: themePrimary.darkest,
                },
                focus: {
                    background: themePrimary.main,
                },
                disabled: {
                    background: themePrimary.main,
                },
            };
        case 'inverse':
            return {
                default: {
                    background: colors.frenchVanilla100,
                    icon: colors.blackPepper400,
                    label: colors.blackPepper400,
                },
                hover: {
                    background: colors.soap300,
                    icon: colors.blackPepper500,
                    label: colors.blackPepper500,
                },
                active: {
                    background: colors.soap400,
                    icon: colors.blackPepper500,
                    label: colors.blackPepper500,
                },
                focus: {
                    background: colors.frenchVanilla100,
                    border: colors.blackPepper400,
                    icon: colors.blackPepper400,
                    label: colors.blackPepper400,
                    focusRing: focusRing({
                        separation: 1,
                        innerColor: colors.blackPepper400,
                        outerColor: colors.frenchVanilla100,
                    }, theme),
                },
                // Identical to inverse 'default' styles. ButtonContainer will set opacity to 40%
                disabled: {
                    background: colors.frenchVanilla100,
                    icon: colors.blackPepper400,
                    label: colors.blackPepper400,
                },
            };
    }
};
export var PrimaryButton = createComponent('button')({
    displayName: 'PrimaryButton',
    Component: function (_a, ref, Element) {
        var _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.iconPosition, iconPosition = _c === void 0 ? 'start' : _c, variant = _a.variant, icon = _a.icon, _d = _a.shouldMirrorIcon, shouldMirrorIcon = _d === void 0 ? false : _d, children = _a.children, elemProps = __rest(_a, ["size", "iconPosition", "variant", "icon", "shouldMirrorIcon", "children"]);
        var theme = useTheme();
        return (React.createElement(BaseButton, __assign({ ref: ref, size: size, colors: getPrimaryButtonColors(variant, theme), padding: getPaddingStyles(children, size, icon, iconPosition), minWidth: getMinWidthStyles(children, size), as: Element }, elemProps),
            icon && iconPosition === 'start' && (React.createElement(BaseButton.Icon, { size: size, iconPosition: iconPosition, icon: icon, shouldMirrorIcon: shouldMirrorIcon })),
            children && React.createElement(BaseButton.Label, null, children),
            icon && iconPosition === 'end' && (React.createElement(BaseButton.Icon, { size: size, iconPosition: iconPosition, icon: icon, shouldMirrorIcon: shouldMirrorIcon }))));
    },
});
